import { AxiosResponse,AxiosError } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TVacationGetReq,
  TVacationGetRes,
  TVacationIndividualGetReq,
  TVacationIndividualGetRes,
  TYyukyuHuyoGetRes,
  TVacationHuyoPostReq,
  TVacationChangeGetRes,
  TVacationChangePutReq,
  TVacationChangePostReq,
  TVacationPrintVacationKanriReq
} from "./TVacation"

/**
 * 出勤簿に対するAPIリクエスト用サービス
 *
 * @export
 * @class VacationService
 * @extends {ConnectApi}
 */
export default class VacationService extends ConnectApi {
  /**
   * 検索取得（有給管理一覧取得）
   *
   * @param {TVacationGetReq} params
   * @param {(param: TApiResponse<TVacationGetReq[]>) => any} resolve
   * @param {(param: TApiResponse<TVacationGetReq[]>) => any} reject
   * @memberof VacationService
   */
  getList = async (params: TVacationGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TVacationGetRes[]>> =
        await this.getInner(`/attendance/vacation`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 有給取得（個人）一覧取得
   *
   * @param {TVacationIndividualGetReq} params
   * @param {(param: TApiResponse<TVacationIndividualGetReq[]>) => any} resolve
   * @param {(param: TApiResponse<TVacationIndividualGetReq[]>) => any} reject
   * @memberof VacationService
   */
  getIndividualList = async (params: TVacationIndividualGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TVacationIndividualGetRes>> =
        await this.getInner(`/attendance/vacation/yukyulist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 有休保有数変更 単体取得
   *
   * @param {number} id
   * @memberof VacationService
   */
  getYukyuChangeList = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TVacationChangeGetRes>> =
        await this.getInner(
          `/attendance/vacation/yukyuchangelist/${id}`,
          signal
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 有休保有数変更 単体更新
   *
   * @param {TVacationChangePostReq} data
   * @memberof VacationService
   */
  postSyaryoSyozokuFrom = async (data: TVacationChangePostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/attendance/vacation/yukyuchangelist/`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 有休保有数変更 単体更新
   *
   * @param {TVacationChangePutReq} data
   * @memberof VacationService
   */
  putSyaryoSyozokuFrom = async (
    id: string | number,
    data: TVacationChangePutReq
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/attendance/vacation/yukyuchangelist/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 有給付与処理 処理状況一覧取得
   *
   * @param {(param: TApiResponse<TYyukyuHuyoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TYyukyuHuyoGetRes[]>) => any} reject
   * @memberof VacationService
   */
  getHuyoList = async () => {
    try {
      const res: AxiosResponse<TApiResponse<TYyukyuHuyoGetRes[]>> =
        await this.getInner(`/attendance/vacation/huyolist`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 有給付与処理　実行
   *
   * @param {TVacationHuyoPostReq} data
   * @param {(param: TApiResponse<TVacationHuyoPostReq>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TVacationHuyoPostReq>>) => any} reject
   * @memberof KyotenService
   */
  postHuyoList = async (data: TVacationHuyoPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/attendance/vacation/huyolist`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 有給管理簿印刷
   *
   * @param {TVacationPrintVacationKanriReq} params
   * @memberof VacationService
   */
  printVacationKanriReq = async (
    params: TVacationPrintVacationKanriReq,
    resolve?: (param: TApiResponse<TVacationPrintVacationKanriReq[]>) => any,
    reject?: (param: AxiosError<TVacationPrintVacationKanriReq[]>) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G080501`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
